import { MetricCard } from "@/components/MetricCard";
import { RecommendationSection } from "@/components/RecommendationSection";
import { Card } from "@/components/ui/card";
import { UserFlowChart } from "@/components/UserFlowChart";
import { PerformanceMetrics } from "@/components/PerformanceMetrics";
import { AccessibilityScores } from "@/components/AccessibilityScores";

const Index = () => {
  const metrics = [
    {
      title: "Navigation & Structure",
      score: 6,
      description: "Menu structure is clear but lacks visual hierarchy and mobile optimization"
    },
    {
      title: "Visual Design",
      score: 5,
      description: "Basic design with limited visual appeal. Needs improvement in color harmony and spacing"
    },
    {
      title: "Content Clarity",
      score: 5,
      description: "Information is comprehensive but needs better organization and formatting"
    },
    {
      title: "Mobile Responsiveness",
      score: 4,
      description: "Significant issues with mobile layout and touch targets"
    }
  ];

  const recommendations = [
    {
      title: "Optimize Mobile Navigation",
      description: "Implement a hamburger menu for mobile devices and ensure all menu items are easily clickable with proper touch target sizes.",
      priority: "High" as const
    },
    {
      title: "Improve Visual Design",
      description: "Update color scheme for better contrast, implement consistent spacing, and enhance typography hierarchy.",
      priority: "High" as const
    },
    {
      title: "Enhance Content Layout",
      description: "Restructure content with clear headings, subheadings, and consistent formatting. Add proper spacing between sections.",
      priority: "High" as const
    },
    {
      title: "Optimize Image Loading",
      description: "Implement lazy loading for images and optimize image sizes to improve page load times.",
      priority: "Medium" as const
    },
    {
      title: "Add Interactive Elements",
      description: "Include hover states for clickable elements and smooth transitions for better user engagement.",
      priority: "Low" as const
    }
  ];

  return (
    <div className="min-h-screen bg-background">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-12">
        <div className="mb-12">
          <h1 className="text-4xl font-bold mb-3 text-foreground">UX Audit Report</h1>
          <p className="text-lg text-muted-foreground">Comprehensive Analysis & Recommendations</p>
        </div>

        <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-4 gap-6 mb-12">
          {metrics.map((metric, index) => (
            <MetricCard
              key={index}
              title={metric.title}
              score={metric.score}
              description={metric.description}
            />
          ))}
        </div>

        <div className="grid grid-cols-1 lg:grid-cols-2 gap-8 mb-12">
          <Card className="p-6">
            <UserFlowChart />
          </Card>
          <Card className="p-6">
            <PerformanceMetrics />
          </Card>
        </div>

        <div className="mb-12">
          <Card className="p-8">
            <AccessibilityScores />
          </Card>
        </div>

        <Card className="p-8">
          <h2 className="text-3xl font-bold mb-6 text-foreground">Key Recommendations</h2>
          <RecommendationSection recommendations={recommendations} />
        </Card>
      </div>
    </div>
  );
};

export default Index;